export default __webpack_public_path__ + "static/media/1181.6274fb16.JPG";